import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { Img as ImgComponent } from "@sunwing/shared-components/dist/Image/index";
import { useAlerts } from "../context";
import { BaseLayout } from "../components/Layouts/BaseLayout";
import { FluidSections } from "../components/FluidSections";

import * as styles from "./404.module.scss";

const ErrorPage = ({ data, pageContext, location }) => {
	/* Retrieve Page Data from the page query */
	const pageData = data.contentfulPage;
	const altLangPages = data.allSitePage;
	const { homepagePaths, defaultHeader, travelAlertsUrl, defaultFooter } = data;

	const { alertsCount } = useAlerts();

	let pageHeader = pageData.headerNavigation;
	let pageFooter = pageData.footer;

	if (!pageHeader) {
		pageHeader = defaultHeader;
	}

	if (!pageFooter) {
		pageFooter = defaultFooter;
	}
	return (
		<BaseLayout
			location={location}
			pageContext={pageContext}
			seo={pageData.seo}
			altLangPages={altLangPages}
			footerData={pageFooter}
			headerNavigation={pageHeader}
			homepagePaths={homepagePaths}
			alerts={alertsCount}
			travelAlertsUrl={travelAlertsUrl?.path}
			pageType={pageData?.pageType}
		>
			<div className={styles?.notFound}>
				<div className={styles?.notFound__bgr}>
					<ImgComponent
						src={pageData?.backgroundImage[0].secure_url}
						alt={pageData?.backgroundImage[0].url}
						autoResponsive={false}
					/>
				</div>
				<div className={styles?.notFound__row}>
					<div className={styles?.notFound__row__inner}>
						<FluidSections data={pageData.sections} />
					</div>
				</div>
			</div>
		</BaseLayout>
	);
};

/* Declare page prop */
ErrorPage.propTypes = {
	data: PropTypes.object.isRequired,
	pageContext: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default ErrorPage;

/* Query page data */
export const pageQuery = graphql`
	query GetErrorPageData($id: String!, $locale: String!, $ctf_id: String!) {
		contentfulPage(id: { eq: $id }) {
			title
			pageType
			backgroundImage {
				secure_url
				width
				height
				raw_transformation
				version
				public_id
				format
			}
			sections {
				__typename
				...Collection
				...ComponentBlock
				...HardCodedComponent
				...LinkWithModal
				...ListLink
				...MultiImageBlock
				...Paragraph
				...PromotionRule
				...Section
				...SplitContentWrapper
				...TabsAndAccordion
				...TimedComponent
				...VideoPlayer
			}
		}
		homepagePaths: allSitePage(filter: { context: { template: { eq: "homepage" } } }) {
			edges {
				...homepagePaths
			}
		}
		allSitePage(filter: { context: { ctf_id: { eq: $ctf_id } } }) {
			edges {
				...LanguageToggle
			}
		}
		defaultHeader: contentfulHeaderNavigation(
			contentful_id: { eq: "4WLelYKXDOXBf7CGGtf52z" }
			node_locale: { eq: $locale }
		) {
			...headerNavigation
		}
		defaultFooter: contentfulFooter(
			contentful_id: { eq: "3TjYjWvnKS88bdse66t4oo" }
			node_locale: { eq: $locale }
		) {
			...Footer
		}
		travelAlertsUrl: sitePage(context: { template: { eq: "alerts" }, locale: { eq: $locale } }) {
			path
		}
	}
`;
